import React from 'react';
import { Box } from '@mui/material';

import AgingBars from './AgingBars';
import FlowCard from './FlowCard';
import KpiRibbon from './KpiRibbon';
import TicketTable from './TicketTable';
import { Page4Data } from './types';

interface Page4ContentProps {
  data: Page4Data;
  onExportCsv?: () => void;
}

const Page4Content: React.FC<Page4ContentProps> = ({ data, onExportCsv }) => (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
    <KpiRibbon kpis={data.kpis} />
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: '1.1fr 1fr' },
        gap: '16px',
      }}
    >
      <FlowCard flow={data.flow} window={data.window} />
      <AgingBars
        incidents={data.aging.incidents}
        serviceRequests={data.aging.service_requests}
      />
    </Box>
    <TicketTable rows={data.rows} onExportCsv={onExportCsv} />
  </Box>
);

export default Page4Content;
